export default __webpack_public_path__ + "static/media/outdoor-bg-1.8dce96c5.png";